// ═══════════════════════════════════════════════════════════════════════════════
// ui--manifesto--magnetic-v3
// ───────────────────────────────────────────────────────────────────────────────
// Wraps Motion One — magnetic кнопка следует за курсором с spring physics.
// Параметры через data-attributes:
//   data-ui--manifesto--magnetic-v3-strength-value = 0..1 (default 0.4)
//   data-ui--manifesto--magnetic-v3-radius-value   = px (default 120)
// ═══════════════════════════════════════════════════════════════════════════════

import { Controller } from "@hotwired/stimulus"
import { animate } from "motion"

export default class extends Controller {
  static values = {
    strength: { type: Number, default: 0.4 },
    radius:   { type: Number, default: 120 },
  }

  connect() {
    this.boundMove  = this.onMove.bind(this)
    this.boundLeave = this.onLeave.bind(this)
    this.element.addEventListener("mousemove",  this.boundMove)
    this.element.addEventListener("mouseleave", this.boundLeave)
    if (window.matchMedia("(hover: none)").matches) {
      // Mobile/touch — disable magnetic (no hover state)
      this.element.removeEventListener("mousemove",  this.boundMove)
      this.element.removeEventListener("mouseleave", this.boundLeave)
    }
  }

  disconnect() {
    this.element.removeEventListener("mousemove",  this.boundMove)
    this.element.removeEventListener("mouseleave", this.boundLeave)
  }

  onMove(e) {
    const r = this.element.getBoundingClientRect()
    const cx = r.left + r.width  / 2
    const cy = r.top  + r.height / 2
    const dx = (e.clientX - cx) * this.strengthValue
    const dy = (e.clientY - cy) * this.strengthValue
    animate(this.element, { x: dx, y: dy }, { type: "spring", stiffness: 220, damping: 18 })
  }

  onLeave() {
    animate(this.element, { x: 0, y: 0 }, { type: "spring", stiffness: 200, damping: 20 })
  }
}
